import type { SampleOrderType } from '@packages/gql/generated/shopping/graphql';

export const getSampleOrderGlycerinDetail = (sampleOrderType: SampleOrderType | null) => {
  switch (sampleOrderType) {
    case 'WOOD':
      return 'Holzmuster';
    case 'UPHOLSTERY':
      return 'Stoffmuster';
    default:
      return undefined;
  }
};
